// Compact team strip on the firm Command Center. Each chip-card links to
// /team/:userId; the trailing link goes to /team. Renders only what
// /api/firm/staff returns - an unreachable server says so, and nothing
// falls back to the prototype team.

import { Link } from "react-router-dom";
import { useFirmStaff } from "../../hooks/useFirmStaff";
import { colorFor } from "../../lib/staffVisuals";
import { initialsOf } from "../../api/auth";
import { Skeleton } from "../chrome/Skeleton";
import { ARROW, SEP } from "../chrome/SepList";

export function TeamSection() {
  const { data: staff, isLoading, isError } = useFirmStaff();

  return (
    <div className="cc-card">
      <div className="cc-card-head">
        <div className="cc-card-title">Team</div>
        {staff && (
          <div className="cc-card-sub">
            {SEP}
            {staff.length} {staff.length === 1 ? "member" : "members"}
          </div>
        )}
        <div className="actions">
          <Link to="/team" className="cc-link-btn" style={{ textDecoration: "none" }}>
            View all team {ARROW}
          </Link>
        </div>
      </div>
      {isLoading && (
        <div style={{ padding: "10px 18px" }}>
          <Skeleton width="100%" height={54} radius={10} />
        </div>
      )}
      {isError && (
        <div style={{ padding: "10px 18px", fontSize: 12, color: "var(--warn-600)" }}>
          Could not reach the server - the team list is unavailable.
        </div>
      )}
      {staff && staff.length === 0 && (
        <div style={{ padding: "10px 18px", fontSize: 12, color: "var(--muted)" }}>
          No staff accounts yet.
        </div>
      )}
      {staff && staff.length > 0 && (
        <div className="team-strip">
          {staff.map((s) => (
            <Link key={s.id} to={`/team/${s.id}`} className="team-strip-card" title={s.fullName}>
              <span className="av" style={{ background: colorFor(s.id) }}>
                {initialsOf(s.fullName)}
              </span>
              <span style={{ display: "flex", flexDirection: "column", minWidth: 0 }}>
                <span className="who">{s.fullName.split(",")[0]}</span>
                <span className="role">{s.role}</span>
              </span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
